import { authBaseUrl, fetchWithSession, readError } from '@ventawiz/web-kit'

/**
 * One request to VentaWiz-Auth's API (`/auth/v1/…`) with the session's token,
 * its error envelope read by the kit — not the backend's, which has a
 * different shape.
 *
 * Through `fetchWithSession`, like every backend call, so a 401 refreshes
 * once. A 204 has no body; `.json()` on it would throw a SyntaxError that
 * reads like a server fault.
 */
export async function authRequest<T>(path: string, init: RequestInit = {}): Promise<T> {
  const headers = new Headers(init.headers)
  if (init.body !== undefined) headers.set('Content-Type', 'application/json')
  const response = await fetchWithSession(
    new Request(`${authBaseUrl()}/v1${path}`, { ...init, headers, credentials: 'include' }),
  )
  const body: unknown = response.status === 204 ? null : await response.json().catch(() => null)
  if (!response.ok) throw readError(response, body)
  return body as T
}
